import Button from '@material-ui/core/Button';
import React, { useEffect, useMemo, useRef } from 'react';
import { channelMessage, newGuid } from '../../../common';
import Composer from './Composer';
import MessageRow from './MessageRow';
import './style.scss';

const { createChannelMessage } = channelMessage;

const ChatterBox = ({
   messages = [],
   currentUser,
   draft,
   onDraftChange,
   onSend,
   onRetryMessage,
   onRemoveMessage,
   submitting,
   error,
   readOnly,
   readOnlyMessage,
   loading,
   loadingError,
   unavailable,
   onRetryLoad,
   formatDateTime,
   renderMediaActions,
   pendingMedia,
   getMessageActions
}) => {
   const endRef = useRef(null);
   const orderedMessages = useMemo(() => [...messages], [messages]);

   useEffect(() => {
      if (endRef.current && typeof endRef.current.scrollIntoView === 'function') {
         endRef.current.scrollIntoView({ block: 'nearest' });
      }
   }, [orderedMessages.length]);

   const submit = () => {
      const text = (draft || '').trim();
      if (!text || submitting || readOnly || !onSend) return;
      onSend(createChannelMessage({ id: newGuid(), text, user: currentUser, createdAt: new Date() }));
   };

   if (unavailable) return <div className='chatterbox-state'>Notes are unavailable for this issue.</div>;

   return (
      <section className='chatterbox'>
         <div className='chatterbox-history'>
            {loading && !orderedMessages.length && <div className='chatterbox-state'>Loading notes…</div>}
            {!loading && loadingError && !orderedMessages.length && (
               <div className='chatterbox-state chatterbox-error'>
                  <span>{loadingError}</span>
                  {onRetryLoad && <Button variant='outlined' color='primary' onClick={onRetryLoad}>Retry</Button>}
               </div>
            )}
            {!loading && !loadingError && !orderedMessages.length && <div className='chatterbox-state'>No notes to display.</div>}
            {orderedMessages.map((message) => (
               <MessageRow
                  key={message._id}
                  message={message}
                  currentUser={currentUser}
                  formatDateTime={formatDateTime}
                  onRetry={onRetryMessage}
                  onRemove={onRemoveMessage}
                  submitting={submitting}
                  actions={getMessageActions ? getMessageActions(message) : []}
               />
            ))}
            <div ref={endRef} />
         </div>
         {loadingError && orderedMessages.length > 0 && <div className='chatterbox-inline-load-error'>{loadingError}</div>}
         {error && <div className='chatterbox-submit-error'>{error}</div>}
         <Composer
            draft={draft}
            onDraftChange={onDraftChange}
            onSend={submit}
            disabled={Boolean(submitting)}
            readOnly={readOnly}
            readOnlyMessage={readOnlyMessage}
            renderMediaActions={renderMediaActions}
            pendingMedia={pendingMedia}
         />
      </section>
   );
};

export default ChatterBox;
